var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcondefaultImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44092_106620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.176758,
    y: 0.046875,
    width: 48,
    height: 48,
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_44092_106620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9308 28.9506C35.5898 28.6549 35.1374 28.4934 34.6696 28.5002C34.2018 28.507 33.7553 28.6817 33.4245 28.9872L25.6609 36.1551C25.3234 36.4667 25.1338 36.8894 25.1338 37.3301C25.1338 37.7708 25.3234 38.1934 25.6609 38.5051L44.0671 55.5C45.1492 54.9189 46.0477 54.0865 46.6734 53.0856C47.2991 52.0847 47.6302 50.9502 47.6338 49.7946V39.1034L35.9308 28.9506Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_44092_106620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1338 25.5C30.6191 25.5 32.6338 23.4853 32.6338 21C32.6338 18.5147 30.6191 16.5 28.1338 16.5C25.6485 16.5 23.6338 18.5147 23.6338 21C23.6338 23.4853 25.6485 25.5 28.1338 25.5Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_44092_106620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1177 23.0161C16.7834 22.6847 16.3408 22.5 15.8807 22.5C15.4206 22.5 14.9779 22.6847 14.6436 23.0161L-3.36621 41.8989V48.1619C-3.36621 50.1081 -2.62883 51.9746 -1.31629 53.3507C-0.00374675 54.7269 1.77644 55.5 3.63266 55.5H38.627C39.8436 55.4963 41.0381 55.159 42.0919 54.5214C43.1457 53.8839 44.022 52.9684 44.6338 51.8658L17.1177 23.0161Z",
    fill: "#FCFCFC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_44092_106620",
    x: 19.1338,
    y: 19.5,
    width: 34.5,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44092_106620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44092_106620",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_44092_106620",
    x: 17.6338,
    y: 7.5,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44092_106620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44092_106620",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_44092_106620",
    x: -9.36621,
    y: 13.5,
    width: 60,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44092_106620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44092_106620",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44092_106620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcondefaultImage);
export default __webpack_public_path__ + "static/media/IcondefaultImage.96510f8bb3f43a93b4550b888069e5b7.svg";
export { ForwardRef as ReactComponent };